import signMsgModel from './sign-msg.vue';
export default{
    install(Vue, pluginOptions = {}){
        const VueItem = Vue.extend(signMsgModel);
        var signMsg = null;
        function $signMsg() {
            return new Promise((resolve) => {
                if(!signMsg) {
                    signMsg = new VueItem();
                    signMsg.$mount(signMsg.$el);
                    document.querySelector('body').appendChild(signMsg.$el);
                }
                resolve();
            })
        };
        $signMsg.show = function(res) {
            return new Promise(() => {
                signMsg.show(res);
            });
        };
        $signMsg.error = function(res) {
            signMsg.error(res);
        };
        $signMsg.confirm = function(res) {
            signMsg.confirm(res);
        };
        $signMsg.hide = function() {
            document.querySelector('body').removeChild(signMsg.$el);
        };

        //初始化
        $signMsg();
        Vue.signMsg = Vue.prototype.$signMsg = $signMsg;
    }
}


// WEBPACK FOOTER //
// ./src/components/sign-msg/sign-msg.js